export function isPublicBookingHost(): boolean {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname;
  if (h === "book.doctrue.in" || h.startsWith("book-staging.")) return true;
  if (process.env.REACT_APP_PUBLIC_BOOKING_HOST === "1") return true;
  return new URLSearchParams(window.location.search).get("public") === "1";
}
